import { toast } from "sonner";
import React, { useState, useRef, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Lightbulb, ArrowRight, Plus, Trash2, Save, Clock, Download, BookOpen } from "lucide-react";
import api from "@/api";
import { useNavigate, useLocation } from "react-router-dom";
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import OldSubmit from "./oldsubmit";


import { useLayoutEffect } from "react";
import ParticipationAwards from "./ParticipationAwards";
import FinalAwards from "./FinalAwards";
import ChairmanAwards from "./ChairmanAwards";  

const tabs = [
  { id: "participation", label: "Participation Awards" },
  { id: "final", label: "Final Awards" },
  { id: "chairman", label: "Chairman's Award" }
];

const Udbhav1Awards = () => {
  const [activeTab, setActiveTab] = useState("participation");

  return (
    <section className="min-h-screen bg-black text-white pt-28 pb-16 px-6">
      <div className="max-w-7xl mx-auto">

        {/* PAGE TITLE */}
        {/* <h1 className="text-6xl font-bold text-center mb-10">
          Udbhav 1.0 – Awards
        </h1> */}

        {/* TABS */}
        <div className="flex justify-center gap-4 mb-3 flex-wrap">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-6 py-3 rounded-xl font-semibold transition-all
                ${
                  activeTab === tab.id
                    ? "bg-red-600 text-white"
                    : "bg-white/10 hover:bg-white/20"
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* TAB CONTENT */}
        {activeTab === "participation" && <ParticipationAwards />}
        {activeTab === "final" && <FinalAwards />}
        {activeTab === "chairman" && <ChairmanAwards />}

      </div>
    </section>
  );
};

export default Udbhav1Awards;
